<template>
  <section class="te-graduate-java co-bg-striped">
    <div class="co-container-md px-5 lg:px-0">
      <div class="co-container-lg py-[3.25rem]">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          卒業生の就職事例
        </h2>
        <div class="flex flex-col items-center justify-center md:flex-row">
          <div class="relative mx-3 mb-[3.25rem] flex w-full flex-col items-center bg-white px-4 py-6 shadow md:mb-0">
            <TeCommonRibbon class="te-ribbon-position te-ribbon-color absolute p-4 font-bold">
              転職成功
            </TeCommonRibbon>
            <div>
              <img
                src="~/assets/images/Te/TeCommon/Graduate/Java/takamatsu.jpg"
                class="rounded-full"
                alt="高松 大樹さん"
                loading="lazy"
              >
            </div>
            <span class="co-display-13 block">高松 大樹さん</span>
            <span class="co-display-13 block">元飲食店 エリアマネージメント</span>
            <p class="co-display-13 mb-0 mt-5 font-bold">
              メンターの生きた業界話がモチベーションになり転職活動から約1ヶ月半で内定獲得
            </p>
          </div>
          <div class="relative mx-3 mb-[3.25rem] flex w-full flex-col items-center bg-white px-4 py-6 shadow md:mb-0">
            <TeCommonRibbon class="te-ribbon-position te-ribbon-color absolute p-4 font-bold">
              転職成功
            </TeCommonRibbon>
            <div>
              <img
                src="~/assets/images/Te/TeCommon/Graduate/Java/takaramoto.jpg"
                loading="lazy"
                class="rounded-full"
                alt="宝本 眞也さん"
              >
            </div>
            <span class="co-display-13 block">宝本 眞也さん</span>
            <span class="co-display-13 block">元メーカー技術職</span>
            <p class="co-display-13 mb-0 mt-5 font-bold">
              フリーランスを見据えて転職！現役エンジニアのアドバイスも受けて転職に成功
            </p>
          </div>
          <div class="relative mx-3 flex w-full flex-col items-center bg-white px-4 py-6 shadow md:mb-0">
            <TeCommonRibbon class="te-ribbon-position te-ribbon-color absolute p-4 font-bold">
              転職成功
            </TeCommonRibbon>
            <div>
              <img
                src="~/assets/images/Te/TeCommon/Graduate/Java/satou.jpg"
                loading="lazy"
                class="rounded-full"
                alt="佐藤 光さん"
              >
            </div>
            <span class="co-display-13 block">佐藤 光さん</span>
            <span class="co-display-13 block">元会社員 営業職</span>
            <p class="co-display-13 mb-0 mt-5 font-bold">
              1ヶ月前倒しで学習を終わらせ、自分の強みを把握し2ヶ月で内定獲得
            </p>
          </div>
        </div>
      </div>
      <div class="co-container-sm">
        <h3 class="te-sub-heading co-display-10 my-4 text-center">
          &lt; 卒業生の年収アップ実例 &gt;
        </h3>
        <div class="flex justify-center bg-white">
          <div class="flex flex-col items-center shadow md:flex-row">
            <div class="size-full p-0 md:w-5/12">
              <img
                src="~/assets/images/Te/TeCommon/Graduate/Java/income.jpg"
                loading="lazy"
                class="w-full"
                alt="年収アップ"
              >
            </div>
            <div class="w-auto px-5 py-4 md:w-7/12">
              <h4 class="co-display-8 mb-4 font-bold">
                転職後の年収アップ金額
              </h4>
              <div class="te-graduate-java-textwrap leading-none">
                <span class="te-graduate-java-text font-bold">平均で約</span>
                <span class="te-graduate-java-text-big font-bold">67</span>
                <span class="te-graduate-java-text font-bold">万円</span>
                <span class="te-graduate-java-text-middle font-bold">アップ！</span>
              </div>
              <p>Javaプログラミングを学習し、就職サポートを受けてエンジニアになられた多くの方が年収アップを実現しています。</p>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <span class="co-display-13 block md:text-right">※金額は卒業生の実績の平均額です。必ずしもこの金額の年収がアップを保証するものではございません。</span>
          <span class="co-display-13 block md:text-right">※初年度の想定年収を元に算出しております。</span>
          <span class="co-display-13 block pb-[4.5rem] md:text-right">※過去に類似コースでJava習得した方の事例です。</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCommonRibbon from '@/components/Te/TeCommon/Ribbon/TeCommonRibbon/TeCommonRibbon.vue';

const options = {
  components: {
    TeCommonRibbon
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/Te/TeCommon/Graduate/TeCommonGraduateJava.css');
</style>
